module.exports = __webpack_public_path__ + "img/34@2x.da14a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/34@2x.png
// module id = JteG
// module chunks = 0